"use client";

import { Modal } from "antd";
import base from "lib/base";
import { sanitizeHtml } from "lib/sanitize";
import styles from "styles/components/author-modal.module.css";

const resolveImage = (path) => {
  if (!path) return null;
  if (/^https?:\/\//i.test(path)) return path;
  const normalizedCdn = (base.cdnUrl || "").replace(/\/+$/, "");
  const normalizedPath = path.replace(/^\/+/, "");
  return `${normalizedCdn}/150x150/${normalizedPath}`;
};

/**
 * Unified Author Modal Component
 * @param {Object} props
 * @param {Object} props.author - Author data object
 * @param {boolean} props.open - Modal visibility state
 * @param {Function} props.onClose - Close handler
 */
const AuthorModal = ({ author, open, onClose }) => {
  if (!author) return null;

  const avatar = resolveImage(author?.avatar);

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      centered
      destroyOnClose
      width={600}
      className={styles.modal}
    >
      <div className={styles.content}>
        <div className={styles.header}>
          {avatar && (
            <div className={styles.avatarWrap}>
              <img
                src={avatar}
                alt={author?.name || "Author"}
                className={styles.avatar}
              />
            </div>
          )}
          <div className={styles.titleBlock}>
            <div className={styles.name}>{author?.name || ""}</div>
            {author?.title && <div className={styles.rank}>{author.title}</div>}
          </div>
        </div>
        {author?.about && (
          <div
            className={styles.about}
            dangerouslySetInnerHTML={{
              __html: sanitizeHtml(author.about),
            }}
          />
        )}
      </div>
    </Modal>
  );
};

export default AuthorModal;
